import React, {useState} from 'react';
import truncateElipse from "./../../../utils/truncateElipse";
import {ArrowContainer} from "react-tiny-popover";
import Popover from "react-tiny-popover";
import ActivityCard from "../../Molecules/ActivityCard";
import styled from "styled-components";
import {withRouter } from 'react-router-dom'

const ActivityWrapper = styled.div`
  pointer-events: none;
  > div {
    background: white;
    margin-bottom: 0;
    max-width: 600px;
  }
`;

function Boxy(props) {
  const [hover, setHover] = useState(false);
  return (
    <svg
      width="168px"
      height="38px"
      viewBox="0 0 168 38"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <defs>
        <rect id="path-1" x={1} y={0} width={160} height={30} rx={4} />
        <filter x="-4.1%" y="-18.3%" width="108.1%" height="143.3%" filterUnits="objectBoundingBox" id="filter-2">
          <feOffset dx={0} dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={2} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix values="0 0 0 0 0.396078431   0 0 0 0 0.466666667   0 0 0 0 0.521568627  0 0 0 0.288156703 0" type="matrix" in="shadowBlurOuter1" />
        </filter>
      </defs>
      <Popover
        isOpen={hover}
        position={'top'} // preferred position
        containerStyle={{ pointerEvents: 'none' }}
        content={({ position, targetRect, popoverRect }) => (
          <ArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
            position={position}
            targetRect={targetRect}
            popoverRect={popoverRect}
            arrowColor={'white'}
            arrowSize={10}
            arrowStyle={{ pointerEvents: 'none' }}
            style={{ pointerEvents: 'none' }}
          >
            <ActivityWrapper>
              <ActivityCard
                activity={props.activity}
                static={true}
              />
            </ActivityWrapper>
          </ArrowContainer>
        )}
      >
        <g id="🖥-Wireframes-Desktop" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd"
           onMouseEnter={ () => setHover(true)}
           onMouseLeave={ () => setHover(false)}
           role={'link'}
           tabIndex={0}
           onFocus={ () => setHover(true) }
           onBlur={ () => setHover(false) }
           aria-label={props.title}
           style={{ cursor: 'pointer'}}
           onClick={ () => props.history.push('/activities/' + encodeURIComponent(props.activity.title.toLowerCase()))}
        >
          <g id="Activities-Protoype-Timeline" transform="translate(-310.000000, -843.000000)">
            <g id="boxy-timepoint-copy" transform="translate(313.000000, 846.000000)">
              <g id="Rectangle">
                <use fill="black" fillOpacity={1} filter="url(#filter-2)" xlinkHref="#path-1" />
                <use fill={props.fill} fillRule="evenodd" xlinkHref="#path-1" />
              </g>
              <text id="People-&-Observation" fontFamily="Inter" x="50%" y="40%" dominantBaseline="middle" textAnchor="middle" fontSize={12} fontWeight={400} linespacing={20} fill="#FFFFFF">
                <tspan>{truncateElipse(props.title,24)}</tspan>
              </text>
            </g>
          </g>
        </g>
      </Popover>
    </svg>
  );
}

export default withRouter(Boxy);
